/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSchemaAttachmentRequest
 */
export interface CreateSchemaAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSchemaAttachmentRequest
     */
    purpose?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSchemaAttachmentRequest
     */
    targetType: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSchemaAttachmentRequest
     */
    targetId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSchemaAttachmentRequest
     */
    targetName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSchemaAttachmentRequest
     */
    active?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateSchemaAttachmentRequest
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateSchemaAttachmentRequest interface.
 */
export function instanceOfCreateSchemaAttachmentRequest(value: object): value is CreateSchemaAttachmentRequest {
    if (!('targetType' in value) || value['targetType'] === undefined) return false;
    if (!('targetId' in value) || value['targetId'] === undefined) return false;
    return true;
}

export function CreateSchemaAttachmentRequestFromJSON(json: any): CreateSchemaAttachmentRequest {
    return CreateSchemaAttachmentRequestFromJSONTyped(json, false);
}

export function CreateSchemaAttachmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSchemaAttachmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'targetType': json['targetType'],
        'targetId': json['targetId'],
        'targetName': json['targetName'] == null ? undefined : json['targetName'],
        'active': json['active'] == null ? undefined : json['active'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function CreateSchemaAttachmentRequestToJSON(json: any): CreateSchemaAttachmentRequest {
    return CreateSchemaAttachmentRequestToJSONTyped(json, false);
}

export function CreateSchemaAttachmentRequestToJSONTyped(value?: CreateSchemaAttachmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'purpose': value['purpose'],
        'targetType': value['targetType'],
        'targetId': value['targetId'],
        'targetName': value['targetName'],
        'active': value['active'],
        'metadata': value['metadata'],
    };
}

